import { useEffect, useState } from "react";
import { Link, useSearchParams } from "react-router-dom";
import { BellOff, Loader2 } from "lucide-react";
import { errMsg, http } from "@/lib/api";
import { usePageTitle } from "@/lib/hooks";

export default function UnsubscribePage() {
  usePageTitle("Unsubscribe");
  const [params] = useSearchParams();
  const token = params.get("token") || "";
  const [state, setState] = useState({ loading: true, brand: "", error: "" });

  useEffect(() => {
    let alive = true;
    http.post(`/alerts/unsubscribe?token=${encodeURIComponent(token)}`)
      .then(({ data }) => { if (alive) setState({ loading: false, brand: data?.brand ?? "", error: "" }); })
      .catch((e) => { if (alive) setState({ loading: false, brand: "", error: errMsg(e) }); });
    return () => { alive = false; };
  }, [token]);

  return (
    <section className="mx-auto flex min-h-[80svh] max-w-xl flex-col items-center justify-center px-5 pb-24 pt-36 text-center" data-testid="unsubscribe-page">
      {state.loading ? <Loader2 className="h-8 w-8 animate-spin text-ph-accent" /> : (
        <>
          <span className="flex h-16 w-16 items-center justify-center rounded-full bg-ph-lime/15 text-ph-accent"><BellOff className="h-7 w-7" /></span>
          <h1 className="mt-6 font-display text-4xl font-extrabold tracking-tight text-ph-ink" data-testid="unsubscribe-title">
            {state.error ? "Link not valid" : "You're unsubscribed"}
          </h1>
          <p className="mt-3 text-ph-muted">{state.error || `You won't receive any more price list alerts for ${state.brand}.`}</p>
          <Link to="/" className="mt-8 rounded-full bg-ph-lime px-6 py-3 text-sm font-semibold text-ph-navy" data-testid="unsubscribe-home">Back to PRICEHUB</Link>
        </>
      )}
    </section>
  );
}
